import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgControls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.14V2H5v10.14a4 4 0 000 7.72V30h2V19.86a4 4 0 000-7.72zm1 4.08A2 2 0 116.22 14 2 2 0 018 16.22zM20 10a4 4 0 00-3-3.86V2h-2v4.14a4 4 0 000 7.72V30h2V13.86A4 4 0 0020 10zm-4 2a2 2 0 112-2 2 2 0 01-2 2zm14 10a4 4 0 00-3-3.86V2h-2v16.14a4 4 0 000 7.72V30h2v-4.14A4 4 0 0030 22zm-4 2a2 2 0 112-2 2 2 0 01-2 2z",
    fill: "#0093d1"
  })));
}

function Controls() {
  return /*#__PURE__*/jsx(SvgControls, {});
}

export { Controls as default };
